import React from 'react'
import { enabledMappingTabs } from './mappingTabs'
import Style from './mappingTabs.module.css'

/**
 * Mapping type picker. The active tab comes straight from the parent's state, so
 * there is no DOM class juggling and no way for the highlight to drift out of sync
 * with what is actually rendered.
 */
const Tabs = ({ instance, activeTab, getActiveTab }) => {
    const tabs = enabledMappingTabs(instance)

    return (
        <div className="col-md-3 col-xl-3">
            <div className="card mndesc">
                <div className={`card-body ${Style.panel}`}>
                    <p className={Style.panelTitle}>Mapping Types</p>
                    <nav>
                        <ul className={Style.list}>
                            {tabs.map((tab) => {
                                const isActive = tab.key === activeTab
                                return (
                                    <li key={tab.key}>
                                        <button
                                            type="button"
                                            className={[Style.item, isActive ? Style.itemActive : ''].join(' ').trim()}
                                            aria-current={isActive ? 'page' : undefined}
                                            onClick={() => getActiveTab(tab.key)}
                                        >
                                            <span className={Style.icon}>
                                                <i className={tab.icon} aria-hidden="true" />
                                            </span>
                                            <span className={Style.text}>
                                                <span className={Style.label}>{tab.label}</span>
                                                <span className={Style.description}>{tab.description}</span>
                                            </span>
                                            <i className={`uil-angle-right ${Style.chevron}`} aria-hidden="true" />
                                        </button>
                                    </li>
                                )
                            })}
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default Tabs
